import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class CompoundConditionIndexUtils {
  static next(compoundConditionGroupIndex, index) {
    const nextIndexSerialized = String(index + 1);
    return compoundConditionGroupIndex.length === 0 ? nextIndexSerialized : compoundConditionGroupIndex + CompoundConditionIndexUtils.DELIMITER + nextIndexSerialized;
  }
}
_defineProperty(CompoundConditionIndexUtils, "DELIMITER", "-");
//# sourceMappingURL=CompoundConditionIndexUtils.js.map
